import { useIsLoading } from "./useIsLoading";
import { useI18n } from "vue-i18n";
import { useFetch } from "nuxt/app";

export function useCustomFetch<T>(
  url: string | (() => string),
  options: any = {},
) {
  const { setIsLoading } = useIsLoading();
  const { locale } = useI18n();

  const loadingId = typeof url === 'string' ? url : url();

  	return useFetch<T>(url, {
		...options,
		key: () => `${typeof url === 'string' ? url : url()}:${locale.value}`,
		watch: [locale],
		onRequest({ options: reqOptions }) {
			setIsLoading(true, loadingId);
			if (reqOptions.headers instanceof Headers) {
				reqOptions.headers.set('Accept-Language', locale.value);
			} else {
				const headers = new Headers(reqOptions.headers as HeadersInit);
				headers.set('Accept-Language', locale.value);
				reqOptions.headers = headers;
			}
		},
		onResponse() {
			setIsLoading(false, loadingId);
		},
		onResponseError() {
			setIsLoading(false, loadingId);
		},
	});
}
